import { useQuery } from "@tanstack/react-query";
import { axiosInterceptor } from "app/services/http-services/request-interceptor";

export interface FlussDefinitionOption {
    id: string;
    name: string;
    definition_key: string;
    is_active: boolean;
}

interface ApiEnvelope<T> {
    data: T;
}

export const flussStartInstancePermission = (definitionKey: string) => `fluss.start_instance:${definitionKey}`;

export const dedupeFlussDefinitions = (definitions: FlussDefinitionOption[]) => {
    const byKey = new Map<string, FlussDefinitionOption>();
    definitions.forEach((definition) => {
        const existing = byKey.get(definition.definition_key);
        if (!existing || (!existing.is_active && definition.is_active)) {
            byKey.set(definition.definition_key, definition);
        }
    });
    return Array.from(byKey.values()).sort((a, b) => a.definition_key.localeCompare(b.definition_key));
};

export const useFlussDefinitions = (enabled = true) => useQuery({
    queryKey: ["fluss", "metadata", "definitions", "permission-array-field"],
    enabled,
    queryFn: async () => {
        const response = await axiosInterceptor.get<ApiEnvelope<FlussDefinitionOption[]>>("/api/fluss/metadata/sys_fluss_definitions");
        return dedupeFlussDefinitions(response.data.data || []);
    },
});
